import type { ReactElement } from 'react';

export default function RouteNotFound(): ReactElement {
	return <p>Route Not Found!</p>;
}
